/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API SSO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreditDto } from '../models';
/**
 * CREDITSApi - axios parameter creator
 * @export
 */
export const CREDITSApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditControllerGetCredits: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/credit/getCredits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "apiKey", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} credit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditControllerSpend: async (credit: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'credit' is not null or undefined
            assertParamExists('creditControllerSpend', 'credit', credit)
            const localVarPath = `/credit/spend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "apiKey", configuration)

            // authentication accessToken required

            if (credit !== undefined) {
                localVarQueryParameter['credit'] = credit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CREDITSApi - functional programming interface
 * @export
 */
export const CREDITSApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CREDITSApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creditControllerGetCredits(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreditDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creditControllerGetCredits(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CREDITSApi.creditControllerGetCredits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} credit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creditControllerSpend(credit: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creditControllerSpend(credit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CREDITSApi.creditControllerSpend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CREDITSApi - factory interface
 * @export
 */
export const CREDITSApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CREDITSApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditControllerGetCredits(options?: RawAxiosRequestConfig): AxiosPromise<CreditDto> {
            return localVarFp.creditControllerGetCredits(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} credit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditControllerSpend(credit: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.creditControllerSpend(credit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CREDITSApi - object-oriented interface
 * @export
 * @class CREDITSApi
 * @extends {BaseAPI}
 */
export class CREDITSApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CREDITSApi
     */
    public creditControllerGetCredits(options?: RawAxiosRequestConfig) {
        return CREDITSApiFp(this.configuration).creditControllerGetCredits(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} credit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CREDITSApi
     */
    public creditControllerSpend(credit: number, options?: RawAxiosRequestConfig) {
        return CREDITSApiFp(this.configuration).creditControllerSpend(credit, options).then((request) => request(this.axios, this.basePath));
    }
}

